/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Insert_End_TcInputs */



/**
* | output |
* | --- |
* | "Insert End TC On Insert" |
*
* @param {Options_Editor_Insert_End_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_insert_end_tc = /** @type {((inputs?: Options_Editor_Insert_End_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Insert_End_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer le TC de fin à l'insertion")
	if (locale === "de") return /** @type {LocalizedString} */ ("TC-Einsatz am Ende einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci fine TC su Inserisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить конец TC при вставке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar extremo TC en inserto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入结束 TC 插入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("挿入終了 TC 挿入時")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इंसर्ट एंड टीसी ऑन इंसर्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir Fim TC em Inserir")
	return /** @type {LocalizedString} */ ("Insert End TC On Insert")
});